import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Wikis, Wiki } from './wiki.model';
import { environment } from './../../environments/environment';

@Injectable()
export class WikiService {

  constructor(private httpClient: HttpClient) {}

  items(query: any): Observable<Wikis> {
    const params = new HttpParams({fromObject: query});
    params['front'] = true;
    return this.httpClient.get<Wikis>(environment.api + '/articles', { params: params });
  }

  item(path: string): Observable<Wiki> {
    return this.httpClient.get<Wiki>(environment.api + '/article/' + path);
  }

}

